import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FAQSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const faqs = [{
    q: 'Come ricevo il materiale?',
    a: "L'accesso è immediato subito dopo l'acquisto. Ricevi un'email con i link per scaricare tutto il materiale digitale sul tuo dispositivo."
  }, {
    q: 'Va bene se sono principiante o se insegno già?',
    a: 'Sì, per entrambe. Il kit ti guida passo dopo passo con istruzioni, temi e sequenze logiche che ti daranno molta sicurezza in aula, che tu abbia appena iniziato o insegni da anni.'
  }, {
    q: 'Per quali stili di yoga funziona?',
    a: 'Le lezioni sono strutturate soprattutto per Hatha e Vinyasa, ma sono facilmente adattabili ad altri stili dinamici o restorativi.'
  }, {
    q: 'In che formato è il materiale?',
    a: 'Tutto il materiale è in PDF di alta qualità, scaricabile da qualsiasi dispositivo: telefono, tablet o computer.'
  }, {
    q: 'Posso stamparlo?',
    a: 'Certo. I PDF sono ottimizzati anche per la stampa, così puoi portare le schede rapide direttamente in aula.'
  }, {
    q: 'I bonus sono inclusi nei € 19?',
    a: 'Sì, tutti e 6 i bonus esclusivi sono inclusi gratuitamente con il tuo acquisto di oggi a € 19.'
  }, {
    q: 'Serve un abbonamento?',
    a: 'No. È un pagamento unico di € 19 e hai accesso a vita a tutto il materiale e ai futuri aggiornamenti.'
  }, {
    q: 'E se non fa per me?',
    a: "Hai 14 giorni di garanzia soddisfatti o rimborsati. Se senti che il kit non fa per te, ci scrivi un'email e ti restituiamo il 100% senza domande."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-white" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text text-center mb-12" data-id="element-42">
          Domande Frequenti
        </h2>

        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, i) => <div key={i} className="bg-[#f9f5ef] rounded-2xl overflow-hidden border border-brand-creamDark/50" data-id="element-44">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-45">
                <span className="font-bold text-brand-text pr-4" data-id="element-46">{faq.q}</span>
                <div className="shrink-0 text-brand-text" data-id="element-47">
                  {openIndex === i ? <X className="w-5 h-5" data-id="element-48" /> : <Plus className="w-5 h-5" data-id="element-49" />}
                </div>
              </button>
              <AnimatePresence data-id="element-50">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-51">
                    <div className="px-6 pb-5 text-brand-gray leading-relaxed" data-id="element-52">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-53">
          <CTAButton onClick={scrollToPricing} className="text-lg py-5 px-10" data-id="element-54">
            SÌ, VOGLIO RISPARMIARE IL MIO TEMPO ORA
          </CTAButton>
        </div>
      </div>
    </section>;
}